import styled from 'styled-components';
import css from 'styled-jsx/css';

export const FloatingVideo = styled.div`
  position: fixed;
  bottom: ${(props) =>
    props.hasStickyStrip
      ? '120px'
      : props.isForLactoPage
        ? '70px'
        : props.fromPdp
          ? '30px'
          : '20px'};
  right: 20px;
  width: 90px;
  height: 160px;
  display: flex;
  justify-content: center;
  align-items: center;
  background: linear-gradient(90deg, #e0e0e0 25%, #f2f2f2 50%, #e0e0e0 75%);
  background-size: 200% 100%;
  animation: shimmer 1.5s infinite;
  text-decoration: none;
  box-shadow: 0 4px 6px rgba(0, 0, 0, 0.1);
  transition:
    background-color 0.3s ease,
    transform 0.2s ease;
  z-index: 500;
  border-radius: 10px;

  @keyframes shimmer {
    0% {
      background-position: -200% 0;
    }
    100% {
      background-position: 200% 0;
    }
  }

  video {
    border-radius: 10px;
    width: 100%;
    height: 100%;
    object-fit: cover;
  }

  @media (min-width: 768px) {
    display: none;
  }

  .viewCount {
    position: absolute;
    bottom: 5px;
    left: -2px;
    color: white;
    padding: 2px 5px;
    border-radius: 0 10px 0 10px;
    display: flex;
    align-items: center;
    font-size: 10px;

    img {
      width: 15px;
      height: 15px;
      margin-right: 5px;
    }
  }
`;

export const CrossButton = styled.div`
  position: absolute;
  top: 0px;
  right: 0px;
  background-color: #000000;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  z-index: 501;
  padding: 3px;
`;

export const CrossButtonFullScreen = styled.div`
  position: absolute;
  top: 20px;
  right: 20px;
  background-color: #000000;
  color: white;
  display: flex;
  justify-content: center;
  align-items: center;
  border-radius: 50%;
  cursor: pointer;
  z-index: 1001;
  padding: 10px;
`;

export const FullScreenVideo = styled.div`
  height: ${(props) =>
    props.remainingHeight ? `${props.remainingHeight}px` : '100vh'};
  width: 100vw;
  scroll-snap-align: start;
  position: ${(props) => (props.openVideoFullScreen ? 'fixed' : 'relative')};

  ${(props) =>
    props.openVideoFullScreen &&
    css`
      top: 0px;
      left: 0px;
      z-index: 10000;
    `}
  video {
    width: 100%;
    height: ${(props) =>
      props.remainingHeight ? `${props.remainingHeight}px` : '100vh'};
    object-fit: cover;
  }

  .viewCount {
    position: relative;
    bottom: 40px;
    left: 10px;
    color: white;
    padding: 2px 5px;
    border-radius: 0 10px 0 10px;
    display: flex;
    align-items: center;
    font-size: 14px;

    img {
      width: 25px;
      height: 25px;
      margin-right: 5px;
    }
  }

  .pauseButton {
    position: absolute;
    top: 50%;
    left: 50%;
    transform: translate(-50%, -50%);
    background-color: transparent;
    border: none;
    cursor: pointer;
    width: 60px; /* Increase size of the circle */
    height: 60px; /* Increase size of the circle */
    border-radius: 50%; /* Circle */
    background-color: rgba(0, 0, 0, 0.5); /* Semi-transparent background */
    display: flex;
    justify-content: center;
    align-items: center;
    padding: 10px; /* Padding inside the circle */
    z-index: 1;
  }

  .pauseButton::after {
    content: '';
    width: 0;
    height: 0;
    border-top: 12px solid transparent;
    border-bottom: 12px solid transparent;
    border-left: 20px solid white;
  }
`;

export const ProductSnippetOuter = styled.div`
  position: absolute;
  bottom: 10px;
  right: 0px;
  z-index: 10;
  width: 100vw;
`;

export const ProductSnippet = styled.div`
  width: 95%;
  background-color: #ffffff;
  margin: auto;
  display: flex;
  padding: 12px;
  gap: 10px;
  border-radius: 10px;

  .addToCart {
    display: flex;
    align-items: center;
    justify-content: center;
  }

  .addToCartBtn {
    color: #fff;
    background-color: #ef4e5e;
    border-radius: 5px;
    font-weight: 600;
    border: none;
    padding: 10px;
    font-size: 12px;
  }

  .opacity {
    opacity: 0.5;
  }
`;

export const ProductImage = styled.div`
  img {
    border-radius: 10px;
  }
`;

export const ProductDetails = styled.div`
  flex: 1;
  .nickname {
    font-size: 12px;
    font-weight: 600;
    color: rgba(0, 0, 0, 0.87);
  }
`;

export const FullScreenVideoContainer = styled.div`
  position: fixed;
  top: 0;
  left: 0;
  width: 100vw;
  height: ${(props) =>
    props.remainingHeight ? `${props.remainingHeight}px` : '100vh'};
  background-color: #000000;
  z-index: 1000;
  overflow-y: hidden;
  overflow-x: hidden;
  display: flex;
  flex-direction: column;
  scroll-snap-type: y mandatory;
  scroll-behavior: smooth;
`;
